var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar__wrapper",style:(("background-image: linear-gradient( to top, " + _vm.bottomColor + " calc(" + _vm.value + "% - 1px), white, " + _vm.topColor + " calc(" + _vm.value + "% + 1px))"))})}
var staticRenderFns = []

export { render, staticRenderFns }